export default __webpack_public_path__ + "static/media/ConfinedSpaceEntry.dd3dca79.pdf";